export default "__VITE_PUBLIC_ASSET__dcc35c75__"